import Super from '../../core/container.gjs';

export default class SpdsLayoutGridContainer extends Super {
  grid = true;
}
